export const clamp = (x) => (isFinite(x) && x > 0 ? x : 0);
